import { createSource } from '@evertrue/et-flux';
import Api from 'entities/helpers/api';

// Helper function to check if an object is a paged response
const isPagedObject = (data) => {
  return (
    data &&
    typeof data === 'object' &&
    !Array.isArray(data) &&
    typeof data.limit === 'number' &&
    typeof data.offset === 'number' &&
    typeof data.total === 'number' &&
    Array.isArray(data.items)
  );
};

const InteractionSearchSource = createSource('InteractionSearchSource', {
  actions: {
    query: true,
    reset: true,
    paginate: true,
    setPage(page) {
      return this.require(typeof page === 'number', 'page should be a number');
    },
    setPageSize(pageSize) {
      return this.require(typeof pageSize === 'number', 'pageSize should be a number');
    },
    sort(prop, reverse) {
      this.require(typeof prop === 'string', 'sort props should be a string');
      return this.require(
        typeof reverse === 'boolean' || reverse === undefined,
        'reverse should be boolean or undefined'
      );
    },
    loading(is_loading) {
      return this.require(typeof is_loading === 'boolean', 'is_loading should be a boolean');
    },
    fetchedInteractions(resp) {
      return this.require(isPagedObject(resp), 'response should be a paged object');
    },
  },

  api: {
    fetch(data) {
      // TODO good to know track here
      this.actions.loading(true);

      return Api.SEARCH.CONTACT_NOTE.post({
        data: JSON.stringify(data?.query || {}),
        params: data?.params,
        success: (resp) => {
          this.actions.fetchedInteractions(resp);
          this.actions.loading(false);
        },
      });
    },

    query() {
      this.actions.query();
    },

    reset() {
      this.actions.reset();
    },

    sort(prop, reverse) {
      this.actions.sort(prop, reverse);
    },

    paginate() {
      this.actions.paginate();
    },

    setPage(page) {
      this.actions.setPage(page);
    },

    setPageSize(pageSize) {
      this.actions.setPageSize(pageSize);
    },
  },
});

export default InteractionSearchSource;
